import React from 'react';

const ToggleButton = ({active, onClick, label, testId}) => (
    <button data-testid={testId} data-active={active} onClick={onClick} className={`px-3 py-1 text-xs font-medium border-none cursor-pointer ${active ? 'bg-main-normal text-white' : 'bg-transparent text-main-normal'}`}>{label}</button>
);

const PrivacyToggle = ({isPublic, onToggle}) => (
    <div className="flex items-center justify-between mb-2">
        <span className="text-[11px] font-semibold text-main-normal tracking-[0.5px]">PRIVACY</span>
        <div className="flex rounded-button overflow-hidden border border-panels-normal">
            <ToggleButton active={isPublic} onClick={() => onToggle(true)} label="Public" testId="privacy-public-button" />
            <ToggleButton active={!isPublic} onClick={() => onToggle(false)} label="Private" testId="privacy-private-button" />
        </div>
    </div>
);

export default PrivacyToggle;
